import { Box } from "@mui/joy";
import type { ZekayCustomer } from "../../../../api/customers/Customer.typed";
import CustomerItem from "./CustomerItem";

type CustomersListProps = {
  customers: ZekayCustomer[] | undefined;
  onOpenProfile: (customer: ZekayCustomer) => void;
  desyncMode?: boolean;
  onDelete?: (customer: ZekayCustomer) => void;
};

export default function CustomersList(props: CustomersListProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        gap: 0,
        width: "100%",
      }}
    >
      {props.customers && props.customers.length > 0
        ? props.customers.map((c) => (
            <CustomerItem
              customer={c}
              key={c.Id}
              onOpenProfile={props.onOpenProfile}
              desyncMode={props.desyncMode}
              onDelete={props.onDelete}
            />
          ))
        : null}
    </Box>
  );
}
